import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { useTitle } from 'react-use';

import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { buildPageTitle } from '@savgroup-front-common/core/helpers';
import { BaseLoader } from '@savgroup-front-common/core/molecules/BaseLoader';

import { useGetOneTimeTokenQuery } from './Invitation.hooks';
import messages from './messages';

export const Invitation: FC = () => {
  useTitle(buildPageTitle([messages.invitationTitlePage]));

  const location = useLocation();
  const search = location.search;

  const searchParams = new URLSearchParams(search);

  const invitationId = searchParams.get('invitation_id') ?? undefined;
  const invitationToken = searchParams.get('invitation_token') ?? undefined;

  const { token } = useGetOneTimeTokenQuery({
    invitationId,
    invitationToken,
  });

  if (!token) {
    return (
      <div>
        <SafeFormattedMessageWithoutSpread message={messages.noToken} />
      </div>
    );
  }

  return <BaseLoader />;
};
